var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_vm._m(0),_vm._l((_vm.list),function(text,index){return _c('div',{key:index,staticClass:"item"},[_c('div',[_c('Download',{attrs:{"path":text.name}})],1)])})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"label"},[_vm._v("附件名称")])])
}]

export { render, staticRenderFns }